export enum EGaCategories {
	ACCOUNT = 'account',
	CATALOG = 'account;catalog',
	DASHBOARD = 'account;dashboard',
	FINANCES = 'account;finances',
	MY_OFFERS = 'account;my offers',
	SOURCES = 'account;my sources',
	ONBOARDING = 'account;onboarding',
	NOTIFICATIONS = 'account;notifications',
	REPORTS = 'account;reports',
}
